import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NbDialogRef, NbDialogService } from "@nebular/theme";
import * as _ from "lodash";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { UserService } from "../../../@core/services/user.service";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";

import { ShopService } from "../../../services/shop.service";
import { ProductService } from "../../../services/product.service";
import { ProductInventoryService } from "../../../services/product-inventory.service";
import { Product, ProductInventory } from "../../../models/product.model";
import * as moment from "moment";

@Component({
  selector: "ngx-dialog-product-inventories-archive",
  templateUrl: "dialog-product-inventories-archive.component.html",
  styleUrls: ["dialog-product-inventories-archive.component.scss"],
})
export class DialogProductInventoriesArchiveComponent
  implements OnInit, OnDestroy
{
  private alive = true;
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header?: string;
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() productId?: string;
  @Input() productCurrent?: Product;

  productArchived?: Product;
  inventories: ProductInventory[] = [];
  receiveQuantity = 0;
  receiveAmount = 0;
  issueQuantity = 0;
  issueAmount = 0;
  balanceQuantity = 0;
  balanceAmount = 0;

  loaded = false;
  loading = false;
  submitted = false;
  changeProduct = false;

  @ViewChild("search") search: ElementRef;
  strSearch = "";

  constructor(
    protected ref: NbDialogRef<DialogProductInventoriesArchiveComponent>,
    private userService: UserService,
    public shopService: ShopService,
    private inventoryService: ProductInventoryService,
    private productService: ProductService,
    private dialogService: NbDialogService,
  ) {}

  ngOnInit() {
    this.loading = true;
    this.productService
      .getById(
        this.productCurrent.shopIdArchived,
        this.productCurrent.archivedId,
      )
      .then((doc) => {
        if (doc.exists) {
          this.productArchived = doc.data();
          console.log(
            "🚀 ~ DialogProductInventoriesArchiveComponent ~ ngOnInit ~ this.productArchived:",
            this.productArchived,
          );
          this.productArchived.id = this.productId;
          this.productArchived.createdOn = convertTimestamp(
            doc.data().createdOn,
          );

          this.getInventories();
        } else {
          this.productArchived = new Product();
          this.productArchived.id = "";
        }

        this.loaded = true;
        this.loading = false;
      })
      .catch((err) => {
        console.log(
          "🚀 ~ DialogProductInventoriesArchiveComponent ~ ngOnInit ~ err:",
          err,
        );

        this.loading = false;
        this.loaded = true;

        this.cancel();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.alive = false;
  }

  cancel() {
    this.ref.close(this.changeProduct);
  }

  //Read
  async getInventories() {
    this.loading = true;

    const querySnapshot = await this.inventoryService.getProductInventories(
      this.productCurrent.shopIdArchived,
      this.productCurrent.archivedId,
      0, // this.productCurrent?.isInitInventory ? 50 : 0,
    );

    this.inventories = [];
    this.receiveQuantity = 0;
    this.receiveAmount = 0;
    this.issueQuantity = 0;
    this.issueAmount = 0;
    this.balanceQuantity = 0;
    this.balanceAmount = 0;

    const initInventory: ProductInventory = new ProductInventory();
    initInventory.comment = "Đầu kỳ";
    initInventory.receiveQuantity = this.productArchived.initQuantity
      ? this.productArchived.initQuantity
      : 0;
    initInventory.receiveAmount = this.productArchived.initAmount
      ? this.productArchived.initAmount
      : 0;
    initInventory.balanceQuantity = initInventory.receiveQuantity;
    initInventory.balanceAmount = initInventory.receiveAmount;

    this.receiveQuantity += initInventory.receiveQuantity;
    this.receiveAmount += initInventory.receiveAmount;
    this.balanceQuantity = initInventory.balanceQuantity;
    this.balanceAmount = initInventory.balanceAmount;

    this.inventories.push(initInventory);

    querySnapshot.forEach((doc) => {
      let prod = new ProductInventory();
      prod = doc.data();
      prod.id = doc.id;
      prod.createdOn = convertTimestamp(prod.createdOn);
      prod.updatedOn = convertTimestamp(prod.updatedOn);
      prod.issueDate = convertTimestamp(prod.issueDate);

      prod.receiveQuantity = prod.receiveQuantity
        ? parseFloat(prod.receiveQuantity.toString())
        : 0;
      this.receiveQuantity += prod.receiveQuantity;
      prod.receiveAmount = prod.receiveAmount ? prod.receiveAmount : 0;
      this.receiveAmount += prod.receiveAmount;

      prod.issueQuantity = prod.issueQuantity
        ? parseFloat(prod.issueQuantity.toString())
        : 0;
      this.issueQuantity += prod.issueQuantity;
      prod.issueAmount = prod.issueAmount ? prod.issueAmount : 0;
      this.issueAmount += prod.issueAmount;

      this.balanceQuantity =
        this.balanceQuantity + prod.receiveQuantity - prod.issueQuantity;
      prod.balanceQuantity = this.balanceQuantity;

      let numb =
        (this.receiveAmount / this.receiveQuantity) * this.balanceQuantity;
      let rounded = Math.round((numb + Number.EPSILON) * 100) / 100;

      this.balanceAmount = this.receiveQuantity > 0 ? rounded : 0;
      prod.balanceAmount = this.balanceAmount;

      this.inventories.push(prod);
    });

    this.productArchived.receiveQuantity = this.receiveQuantity;
    this.productArchived.receiveAmount = this.receiveAmount;
    this.productArchived.issueQuantity = this.issueQuantity;
    this.productArchived.issueAmount = this.issueAmount;
    this.productArchived.balanceQuantity = this.balanceQuantity;
    this.productArchived.balanceAmount = this.balanceAmount;

    if (
      !this.productCurrent?.isInitInventory ||
      this.productCurrent?.initInventoryQuantity !== this.balanceQuantity
    ) {
      this.changeProduct = true;
      this.createInventory(this.productArchived);

      // if (this.productCurrent.initInventoryQuantity !== this.balanceQuantity) {
      //   this.changeProduct = true;
      //   this.createInventory(this.productArchived);
      // } else {
      //   //set status product isInitInventory = true to avoid create inventory again
      //   this.productCurrent.isInitInventory = true;
      // }
    }
  }

  private createInventory(productArchived: Product) {
    let prodInventory = new ProductInventory();
    const quantity = Number(productArchived.balanceQuantity.toFixed(2));
    const price =
      productArchived.balanceQuantity > 0
        ? Math.round(
            productArchived.balanceAmount / productArchived.balanceQuantity,
          )
        : Number(productArchived.costPrice);
    const amount = price * quantity;
    prodInventory.receivePrice = Number(price);
    prodInventory.receiveQuantity = quantity;
    prodInventory.receiveAmount = Math.round(amount * 100) / 100;

    this.loading = true;

    if (
      !this.productCurrent?.initInventoryId ||
      this.productCurrent?.initInventoryId === ""
    ) {
      prodInventory.issueDate = moment().startOf("month").toDate();
      prodInventory.shopId = this.productCurrent.shopId;
      prodInventory.productId = this.productCurrent.id;
      prodInventory.productCode =
        productArchived.code || productArchived.barcode;
      prodInventory.productName = productArchived.title || "";
      prodInventory.productUnitName = productArchived.unitName || "";
      prodInventory.comment = "Tồn đầu kỳ";
      prodInventory.isReceive = true;

      prodInventory.issuePrice = 0;
      prodInventory.issueQuantity = 0;
      prodInventory.issueAmount = 0;
      prodInventory.type = "INITIAL";

      this.inventoryService
        .create(prodInventory)
        .then((dataP) => {
          console.log(
            "🚀 ~ DialogProductInventoriesArchiveComponent ~ createInventory ~ dataP:",
            dataP,
          );
          prodInventory.id = dataP.id;

          this.productCurrent.isInitInventory = true;
          this.productCurrent.initInventoryId = prodInventory.id;
          this.productCurrent.initInventoryQuantity =
            prodInventory.receiveQuantity;
          this.productCurrent.initInventoryDate = prodInventory.issueDate;

          this.productService.updateInitInventory(
            this.productCurrent.shopId,
            this.productCurrent.id,
            this.productCurrent.isInitInventory,
            this.productCurrent.initInventoryId,
            this.productCurrent.initInventoryQuantity,
            this.productCurrent.initInventoryDate,
          );

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    } else {
      this.inventoryService
        .updateInitInventory(
          this.productCurrent.shopId,
          this.productCurrent.initInventoryId,
          prodInventory.receivePrice,
          prodInventory.receiveQuantity,
          prodInventory.receiveAmount,
        )
        .then(() => {
          this.productCurrent.isInitInventory = true;

          this.productService.updateInitInventory(
            this.productCurrent.shopId,
            this.productCurrent.id,
            this.productCurrent.isInitInventory,
            this.productCurrent.initInventoryId,
            prodInventory.receiveQuantity,
            this.productCurrent.initInventoryDate,
          );

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    }
  }
}
